import React from 'react';
import { Price, Typography } from 'fronton-react';
import { getTextColor } from './helpers';
import { PriceBlock } from './styles';

type TProps = {
  isDisable: boolean;
  counter: number;
  price: number | null;
};

export const ComplimentaryBlockPrice = ({ isDisable, counter, price }: TProps) => {
  const totalPrice = price ? price * counter : 0;
  const textColor = getTextColor(isDisable);
  return (
    <PriceBlock>
      <Price
        color={textColor}
        align="center"
        size="l"
        units={counter > 1 ? '₽' : `₽ / шт.`}
        value={totalPrice}
        variant="medium"
        fraction
      />
      {counter > 1 && price ? (
        <Typography size="caption" variant="minor" color={textColor}>
          {`${price} ₽ / шт.`}
        </Typography>
      ) : null}
    </PriceBlock>
  );
};
